var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBrandBuilder24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_brand_builder24x24",
    transform: "translate(-6988.101 -2117.9)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46223",
    d: "M7002.1,2119.1a1.078,1.078,0,0,0-1.1-1.2h-11.5a1.216,1.216,0,0,0-1.2,1.2v1.2h13.8v-1.2Zm-12.4.8a.8.8,0,1,1,.8-.8h0c-.1.4-.4.8-.8.8Zm1.8,0a.8.8,0,1,1,.8-.8h0c-.1.4-.4.8-.8.8Zm1.8,0a.8.8,0,1,1,.8-.8h0c-.1.4-.4.8-.8.8Z",
    transform: "translate(-.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46224",
    d: "M6990.3,2123h4v4.9h-4Z",
    transform: "translate(0 .583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46225",
    d: "M6996.8,2131.4l-.6,1.9a.337.337,0,0,0,.3.5h.3l1.9-.6-.9-.9Z",
    transform: "translate(-.012 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46226",
    d: "M6997.4,2130.5l-.2.2,2.2,2.2,5.6-5.6-2.2-2.2-1.2,1.2Z",
    transform: "translate(-.027 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46227",
    d: "M6998.1,2128.4h-1.7c-.1,0-.3-.1-.3-.2s.1-.3.2-.3h2.2l1.3-1.3h-3.5c-.1,0-.3-.1-.3-.2s.1-.3.2-.3h4l.7-.7,1-1v-3.7h-13.8v8a1.155,1.155,0,0,0,1.2,1.2h7.1Zm-1.6-5.9h3.9c.1,0,.3.1.3.2s-.1.3-.2.3h-3.9c-.1,0-.3-.1-.3-.2-.1-.1,0-.3.2-.3Zm0,1.8h3.9c.1,0,.3.1.3.2s-.1.3-.2.3h-3.9c-.1,0-.3-.1-.3-.2-.1-.1,0-.2.2-.3Zm-1.7,3.9a.319.319,0,0,1-.3.3H6990a.319.319,0,0,1-.3-.3h0v-5.4a.319.319,0,0,1,.3-.3h4.5a.319.319,0,0,1,.3.3h0Z",
    transform: "translate(0 .624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46228",
    d: "M7003.4,2124.533l.718-.73a.307.307,0,0,1,.41,0h0l1.845,1.878a.321.321,0,0,1,0,.417h0l-.718.73Z",
    transform: "translate(-.348 .366)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBrandBuilder24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_brand_builder24x24.9f0a398c295974a4c00269adc76d7221.svg";